import Calc from '@/components/Calc.vue';
import Events from '@/components/Events.vue';
import Files from '@/components/Files.vue';
import DataExport from "@/pages/DataExport/DataExport.vue";
import MasterData from "@/components/MasterData.vue";
import Help from '@/components/Help.vue';
import KpiPanel from '@/components/KpiPanel.vue';
import KviShoppingCart from '@/components/KviShoppingCart.vue';
import PackageAndSchedule from '@/components/PackageAndSchedule.vue';
import PromoCalc from '@/components/PromoCalc.vue';
import SalesManagement from '@/pages/Sales/SalesManagement.vue';
import ModuleManagement from '@/pages/ModuleItems/ModuleManagement.vue';
import Reports from '@/components/Reports.vue';
import ResultsMonitor from '@/components/ResultsMonitor.vue';
import Revaluation from '@/components/Revaluation.vue';
import ScenarioAnalysisPage from '@/components/ScenarioAnalysis.vue';
import Settings from '@/components/Settings.vue';
import SupportPage from '@/components/SupportPage.vue';
import Users from '@/components/Users.vue';
import OmnichannelStrategyPage from '@/pages/omnichannel-strategy/OmnichannelStrategyPage.vue';
import Vue from 'vue';
import Router from 'vue-router';
import {FileType} from './interfaces/server-data';
import FixedPrices from "@/pages/FixedPrices/FixedPricesCommon.vue";
import MonitoringPrice from "@/components/MonitoringPrice/MonitoringPrice.vue";
import {isLoginPage} from "@/utils/isLoginPage";
import { keycloakAuthService } from '@/services/keycloakAuth';
import { isAuthCallbackPage } from "@/utils/isAuthCallbackPage";
import { getEnv } from '@/runtime-config';
import {
  gate, isLocalStorageUsable, noteLeavingToLogin, probeSession, pulse, raise,
  readLocalTokenKind, rememberReturnUrl, saveReason,
} from '@/services/session/sessionState';

Vue.use(Router);

const CompetitorsFiles = Vue.extend({mixins: [Files]});
const LastPricesFiles = Vue.extend({mixins: [Files]});
const PromoFiles = Vue.extend({mixins: [Files]});
const KviCartsFiles = Vue.extend({mixins: [Files]});

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/results-monitor',
      name: 'ResultsMonitor',
      component: ResultsMonitor,
    },
    {
      path: '/kpi-panel',
      name: 'KpiPanel',
      component: KpiPanel,
    },
    {
      path: '/package-calc',
      name: 'PackageCalc',
      component: PackageAndSchedule,
    },
    {
      path: '/calc',
      name: 'Calc',
      component: Calc,
    },
    {
      path: '/scenario-analysis',
      name: 'ScenarioAnalysisPage',
      component: ScenarioAnalysisPage,
    },
    {
      path: '/kviShoppingCart',
      name: 'KviShoppingCart',
      component: KviShoppingCart,
    },
    {
      path: '/monitoring-price',
      name: 'monitoringPrice',
      component: MonitoringPrice
    },
    {
      path: '/files',
      name: 'Files',
      component: Files,
      props: {type: FileType.BASE},
    },
    {
      path: '/data-export',
      name: 'DataExport',
      component: DataExport,
    },
    {
      path: '/master-data',
      name: 'MasterData',
      component: MasterData
    },
    {
      path: '/competitors-files',
      name: 'CompetitorsFiles',
      component: CompetitorsFiles,
      props: {type: FileType.COMPETITORS},
    },
    {
      path: '/lastprices-files',
      name: 'LastPricesFiles',
      component: LastPricesFiles,
      props: {type: FileType.LASTPRICES},
    },
    {
      path: '/promo-files',
      name: 'PromoFiles',
      component: PromoFiles,
      props: {type: FileType.PROMO},
    },
    {
      path: '/kviCarts-files',
      name: 'KviCartsFiles',
      component: KviCartsFiles,
      props: {type: FileType.KVICARTS},
    },
    {
      path: '/omnichannel-strategy',
      name: 'OmnichannelStrategyPage',
      component: OmnichannelStrategyPage,
    },
    {
      path: '/fixed-prices',
      name: 'FixedPrices',
      component: FixedPrices,
      props: {type: FileType.FIXED_PRICE},
    },
    {
      path: '/revaluation',
      name: 'Revaluation',
      component: Revaluation,
    },
    // {
    //   path: '/promo',
    //   name: 'Promo',
    //   component: PromoCalc,
    // },
    {
      path: '/promotions',
      name: 'Promotions',
      component: ModuleManagement,
      props: () => ({ moduleType: 'promo' }),
      // props: () => ({ moduleType: 'sales' }),
    },
    {
      path: '/promotions/:reportId',
      name: 'PromotionReportDetail',
      component: ModuleManagement,
      props: () => ({ moduleType: 'promo', activeTabKeyProp: 'reportsLogTab' }),
      // props: () => ({ moduleType: 'sales', activeTabKeyProp: 'reportsLogTab' }),
    },
    {
      path: '/sales',
      name: 'Sales',
      component: SalesManagement,
    },
    {
      path: '/sales/:reportId',
      name: 'SalesReportDetail',
      component: SalesManagement,
      props: () => ({ activeTabKeyProp: 'reportsLogTab' })
    },
    {
      path: '/events',
      name: 'Events',
      component: Events,
    },
    {
      path: '/reports',
      name: 'Report',
      component: Reports,
    },
    {
      path: '/reports/:id',
      name: 'ReportDetail',
      component: Reports,
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
    },
    {
      path: '/support',
      name: 'SupportPage',
      component: SupportPage,
    },
    {
      path: '/',
      redirect: '/results-monitor',
    }
  ],
});

if (getEnv('AUTH_MODE') === 'keycloak') {
  router.beforeEach((to, from, next) => {
    if (!isLoginPage() && !isAuthCallbackPage()) {
      if (!keycloakAuthService.isAuthenticated()) {
        keycloakAuthService.clearData();

        window.history.replaceState(null, '', '/login');
      } else {
        next();
      }
    } else {
      next();
    }
  });
} else {
  router.beforeEach((to, from, next) => {
    if (isLoginPage() || isAuthCallbackPage()) {
      next();
      return;
    }

    // Хранилище может быть недоступно (приватный режим Safari) — тогда считаем токен живым
    const kind = isLocalStorageUsable() ? readLocalTokenKind() : 'FRESH';

    const isColdStart = from.matched.length === 0;

    // Список разрешающий, а не запрещающий: локально уводим на вход, только когда отправлять нечего.
    // У EXPIRED часы могут спешить, у MALFORMED формат токена задаёт бэкенд — там решает сервер.
    if (isColdStart && (kind === 'ABSENT' || kind === 'CORRUPT')) {
      rememberReturnUrl(to.fullPath);
      // Иначе на логине «сессия истекла» увидел бы тот, кто просто не входил
      if (kind !== 'ABSENT') {
        saveReason('AUTH_STORAGE_CORRUPT', kind);
      }
      noteLeavingToLogin();
      try {
        localStorage.removeItem('AUTH');
        localStorage.removeItem('userData');
      } catch (e) { /* ignore */ }
      // location.replace, а не next(false): vue-router иначе делает pushState('/') и мусорит историю.
      window.location.replace('/login');
      return;
    }

    // Карточку поднимают и сетевые сбои — при них сессия жива, навигацию не запрещаем
    if (gate.kind === 'SESSION_EXPIRED' || gate.kind === 'AUTH_STORAGE_CORRUPT') {
      pulse('navigation');
      next(false);
      return;
    }

    if (kind !== 'FRESH') {
      if (kind === 'CORRUPT') {
        raise({ kind: 'AUTH_STORAGE_CORRUPT', sub: 'ON_NAVIGATION', url: '', status: null });
      } else {
        probeSession().then((alive) => {
          if (!alive) {
            raise({ kind: 'SESSION_EXPIRED', sub: 'LOCAL_EXP_CONFIRMED', url: '', status: 401 });
          }
        });
      }
    }

    next();
  });
}

export default router;
